"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defines a macro.
 *
 * <pre>
 * {% macro input(name, value, type, size) %}
 *    <input type="{{ type|default('text') }}" name="{{ name }}" value="{{ value|e }}" size="{{ size|default(20) }}" />
 * {% endmacro %}
 * </pre>
 */
const token_1 = require("../token");
const token_parser_1 = require("../token-parser");
const syntax_1 = require("../error/syntax");
const body_1 = require("../node/body");
const macro_1 = require("../node/macro");
const varValidator = require('var-validator');
class TwingTokenParserMacro extends token_parser_1.TwingTokenParser {
    parse(token) {
        let lineno = token.getLine();
        let columnno = token.getColumn();
        let stream = this.parser.getStream();
        let name = stream.expect(token_1.TwingToken.NAME_TYPE).getValue();
        let safeName = name;
        if (!varValidator.isValid(name)) {
            safeName = Buffer.from(name).toString('hex');
        }
        let macroArguments = this.parser.getExpressionParser().parseArguments(true, true);
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        this.parser.pushLocalScope();
        let body = this.parser.subparse([this, this.decideBlockEnd], true);
        if (token = stream.nextIf(token_1.TwingToken.NAME_TYPE)) {
            let value = token.getValue();
            if (value != name) {
                throw new syntax_1.TwingErrorSyntax(`Expected endmacro for macro "${name}" (but "${value}" given).`, stream.getCurrent().getLine(), stream.getSourceContext());
            }
        }
        this.parser.popLocalScope();
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let nodes = new Map([
            [0, body]
        ]);
        this.parser.setMacro(name, new macro_1.TwingNodeMacro(safeName, new body_1.TwingNodeBody(nodes), macroArguments, lineno, columnno, this.getTag()));
        return null;
    }
    decideBlockEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endmacro');
    }
    getTag() {
        return 'macro';
    }
}
exports.TwingTokenParserMacro = TwingTokenParserMacro;
